import { translate } from '@/domain/utils/translate';
import { lowercaseCapitalValidation, numberandSymbolValidation } from '@/domain/genericValidations/usePasswordValidation';

export interface ValidatePasswordResult {
  hasError: boolean;
  message: string;
}

export function validateNewPassword(
  password: string,
  email: string,
  requiredFieldMsg = translate('session.error_empty_fields'),
): ValidatePasswordResult {
  if (password.length < 1) {
    return { hasError: true, message: requiredFieldMsg };
  }
  if (password.length < 8 || password.length > 16) {
    return { hasError: true, message: translate('session.length_rule_label') };
  }
  if (!lowercaseCapitalValidation(password)) {
    return { hasError: true, message: translate('session.words_rule_label') };
  }
  if (!numberandSymbolValidation(password)) {
    return { hasError: true, message: translate('session.characters_rule_label') };
  }
  if (password.toUpperCase() === email.toUpperCase()) {
    return { hasError: true, message: translate('session.same_email_rule_label') };
  }
  return { hasError: false, message: '' };
}
